var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.851,
    height: 13.668,
    viewBox: "0 0 16.851 13.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M43.336,15.668a9.742,9.742,0,0,0,9.83-9.83V5.37a7.61,7.61,0,0,0,1.685-1.779,7.772,7.772,0,0,1-1.966.562,3.642,3.642,0,0,0,1.5-1.872,8.587,8.587,0,0,1-2.153.843A3.343,3.343,0,0,0,49.7,2a3.517,3.517,0,0,0-3.464,3.464,1.825,1.825,0,0,0,.094.749,9.679,9.679,0,0,1-7.115-3.651,3.585,3.585,0,0,0-.468,1.779,3.72,3.72,0,0,0,1.5,2.9,3.156,3.156,0,0,1-1.592-.468h0a3.421,3.421,0,0,0,2.809,3.37,2.886,2.886,0,0,1-.936.094,1.593,1.593,0,0,1-.655-.094,3.547,3.547,0,0,0,3.277,2.434,7.068,7.068,0,0,1-4.306,1.5A2.592,2.592,0,0,1,38,13.983a8.836,8.836,0,0,0,5.336,1.685",
    transform: "translate(-38 -2)",
    fill: "#e73758",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f185c3060c9a9d1b2b27d29acb20d066.svg";
export { ForwardRef as ReactComponent };